import { Skeleton } from "@/components/ui/skeleton";

/** Loading shape for the reviews and Q&A lists: avatar, name line, two text lines per row. */
export function ListSkeleton({ rows }: { rows: number }) {
  return (
    <div className="space-y-6" aria-hidden>
      {Array.from({ length: rows }, (_, i) => (
        <div key={i} className="space-y-3" style={{ animationDelay: `${i * 80}ms` }}>
          <div className="flex items-center gap-3">
            <Skeleton className="h-10 w-10 rounded-full shrink-0" />
            <Skeleton className="h-4 w-32" />
          </div>
          <Skeleton className="h-4 w-full" />
          <Skeleton className="h-4 w-2/3" />
        </div>
      ))}
    </div>
  );
}
